<template>
  <section>
    <div class="container" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
      <div>
        <v-header></v-header>
      </div>
      <div class="paperdetail">
        <div style="padding-left: 50%; font-size: 30px; font-weight: bold">{{ PaperDetail.title }}</div>
        <div style="display: flex; padding-top: 20px">
          <div style="padding-left: 30%; font-size: 15px">
            
          </div>
          <div style="padding-left: 1%; font-size: 15px">
            <span v-if="PaperDetail.createUserId == 1">组卷人：Admin</span>
          </div>
          <div style="padding-left: 1%; font-size: 15px">
            
          </div>
          <div style="padding-left: 26%; font-size: 15px">
            <span>总分：{{ PaperDetail.totalScore }}</span>
          </div>
        </div>
      </div>
      <div class="zhuti">
          <!-- 所以题目 -->
        <div class="all-questions">
            <!-- 单选题 -->
            <div class="dxt-questions" v-show="dxt != 0  && abc[QuestionIndex].type==1">
                <div class="title"  >
                    <span style="padding-left: 30px">单选题</span>
                    <span style="padding-left: 10px">(共{{ dxt }}题，合计{{ dxtSum }}分)</span>
                </div>
                <div class="questions-answers-box" v-for="(item, index) in abc" :key="index" v-show="item.type == 1 && index==QuestionIndex" @click="btnindex(item,index)" v-clickDown>
                        <!-- 题目和答题区域 -->
                    <div class="questions-answers" v-show="index==QuestionIndex">
                        <div class="questions" >
                            <!-- 题目展示 -->
                            <div class="subject">
                                    <span>
                                        {{ index + 1 }}.
                                    </span>
                                    <span
                                    v-html="item.title"
                                    :id="item.title"
                                    ></span>
                            </div>
                            <div class="biaoji-container">
                                <div class="biaoji">
                                    <el-tooltip class="item" effect="dark" content="取消标记" placement="top">
                                    <svg v-if="item.bjStatus == true" class="icon" @click="biaoji(item, index)">
                                        <use xlink:href="#iconbiaoji" />
                                    </svg>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" content="标记" placement="top">
                                    <svg v-if="item.bjStatus == false" class="icon" @click="biaoji(item, index)">
                                        <use xlink:href="#iconmark" />
                                    </svg>
                                    </el-tooltip>
                                </div>
                                <div class="icon-analysis" @click="btnAnalysis(item,index)">
                                    <i class="el-icon-chat-line-round" style="color: orange; margin-right: 10px;"></i>
                                    <span class="icon-label">查看解析</span>
                                </div>
                            </div>
                        </div>
                        <!-- 选择区域 -->
                        <div class="choose">
                            <ul>
                                <li
                                v-for="(items, indexs) in item.answer"
                                :key="indexs"
                                @click="radioChange(index, indexs, item)"
                                >
                                <label :for="item.Id" class="xz-label">
                                    <input
                                    type="radio"
                                    v-model="item.value"
                                    :value="items.Id"
                                    @change="radioChange(index, indexs, item)"
                                    :id="item.Id"
                                    style=" margin-right: 10px;"
                                    />
                                    {{ items.Name }}
                                </label>
                                </li>
                            </ul>
                            <div class="answer" v-if="item.Status==true">
                                <div v-for="(items, indexs) in item.answer" :key="indexs" :id="items.Name" class="right-key" >
                                    <span class="right-keys" v-if="indexs == 0 && items.IsRight == true">正确答案：A</span>
                                    <span class="right-keys" v-if="indexs == 1 && items.IsRight == true">正确答案：B</span>
                                    <span class="right-keys" v-if="indexs == 2 && items.IsRight == true">正确答案：C</span>
                                    <span class="right-keys" v-if="indexs == 3 && items.IsRight == true">正确答案：D</span>
                                    <span class="select-keys" v-if="indexs == 0 && items.IsCheck == true">你选择的答案：A</span>
                                    <span class="select-keys" v-if="indexs == 1 && items.IsCheck == true">你选择的答案：B</span>
                                    <span class="select-keys" v-if="indexs == 2 && items.IsCheck == true">你选择的答案：C</span>
                                    <span class="select-keys" v-if="indexs == 3 && items.IsCheck == true">你选择的答案：D</span>
                                </div>
                                <div class="no-answer" v-if="item.value == ''">
                                    <span>你选择的答案：未作答</span>
                                </div>
                                <div class="facility-value">
                                    <span v-if="item.level == 127">难易度：易</span>
                                    <span v-if="item.level == 128">难易度：较易</span>
                                    <span v-if="item.level == 129">难易度：一般</span>
                                    <span v-if="item.level == 130">难易度：较难</span>
                                    <span v-if="item.level == 131">难易度：难</span>
                                </div>
                            </div>
                            <div class="analysis" v-if="item.Status==true">
                                <span>解析：{{ item.explain }}</span>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <!-- 多选题 -->
            <div class="dxt-questions" v-show="ddxt != 0  && abc[QuestionIndex].type==2">
                <div class="title" v-show="ddxt != 0 && abc[QuestionIndex].type==2">
                    <span style="padding-left: 30px">多选题</span>
                    <span style="padding-left: 10px">(共{{ ddxt }}题，合计{{ ddxtSum }}分)</span>
                </div>
                <div class="questions-answers-box" v-for="(item, index1) in abc" :key="index1" v-show="item.type == 2 && index1==QuestionIndex" @click="btnindex(item,index1)" v-clickDown>
                    <div class="questions-answers" v-show="index1==QuestionIndex">
                        <div class="questions">
                            <div class="subject">
                                    <span>
                                        {{ index1 + 1 }}.
                                    </span>
                                    <span
                                    v-html="item.title"
                                    :id="item.title"
                                    ></span>
                            </div>
                           
                            <div class="biaoji-container">
                                <div class="biaoji">
                                    <el-tooltip class="item" effect="dark" content="取消标记" placement="top">
                                    <svg v-if="item.bjStatus == true" class="icon" @click="biaoji(item, index1)">
                                        <use xlink:href="#iconbiaoji" />
                                    </svg>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" content="标记" placement="top">
                                    <svg v-if="item.bjStatus == false" class="icon" @click="biaoji(item, index1)">
                                        <use xlink:href="#iconmark" />
                                    </svg>
                                    </el-tooltip>
                                </div>
                                <div class="icon-analysis" @click="btnAnalysis(item,index1)">
                                    <i class="el-icon-chat-line-round" style="color: orange; margin-right: 10px;"></i>
                                    <span class="icon-label">查看解析</span>
                                </div>
                            </div>
                        </div>
                        <div class="choose">
                            <ul>
                                <li v-for="(items, indexs1) in item.answer" :key="indexs1" :id="items.Name" >
                                <label :for="item.Id"  class="xz-label">
                                    <input
                                    type="checkbox"
                                    v-model="items.IsCheck"
                                    :value="items.Id"
                                    @change="checkboxChange(index1, indexs1, item)"
                                    style="margin-right: 10px;"
                                    :id="item.Id"
                                />
                                    {{items.Name}}
                                </label>
                                </li>
                            </ul>
                            <div class="answer" v-if="item.Status==true">
                                <div class="rightanswer">
                                    <div>正确答案：</div>
                                    <div v-for="(items, indexs) in item.answer" :key="indexs" class="right-key">
                                        <span v-if="indexs == 0 && items.IsRight == true">A</span>
                                        <span v-if="indexs == 1 && items.IsRight == true">B</span>
                                        <span v-if="indexs == 2 && items.IsRight == true">C</span>
                                        <span v-if="indexs == 3 && items.IsRight == true">D</span>
                                    </div>
                                </div>
                                <div class="mychange">
                                    <div  v-if="item.MyCate != ''">我选择的答案：</div>
                                    <div v-for="(aaa, bbb) in item.CheckAnswer" :key="bbb">
                                    <span v-if="aaa.Value == 1">A</span>
                                    <span v-if="aaa.Value == 2">B</span>
                                    <span v-if="aaa.Value == 3">C</span>
                                    <span v-if="aaa.Value == 4">D</span>
                                    </div>
                                </div>
                                <div class="no-answer" v-if="item.MyCate == ''">
                                    <span>我选择的答案：未作答</span>
                                </div>
                                <div class="facility-value">
                                    <span v-if="item.level == 127">难易度：易</span>
                                    <span v-if="item.level == 128">难易度：较易</span>
                                    <span v-if="item.level == 129">难易度：一般</span>
                                    <span v-if="item.level == 130">难易度：较难</span>
                                    <span v-if="item.level == 131">难易度：难</span>
                                </div>
                            </div>
                            <div class="analysis" v-if="item.Status==true">
                                <span>解析：{{ item.explain }}</span>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <!-- 判断题 -->
            <div class="dxt-questions" v-show="pdt != 0  && abc[QuestionIndex].type==3">
                <div class="title" v-show="pdt != 0 && abc[QuestionIndex].type==3">
                    <span style="padding-left: 30px">判断题</span>
                    <span style="padding-left: 10px">(共{{ pdt }}题，合计{{ pdtSum }}分)</span>
                </div>
                <div class="questions-answers-box" v-for="(item, index2) in abc" :key="index2" v-show="item.type == 3 && index2==QuestionIndex" @click="btnindex(item,index2)" v-clickDown>
                    <div class="questions-answers" v-show="showQuestion[index2]==QuestionIndex">
                        <div class="questions">
                            <div class="subject">
                                    <span>
                                        {{ index2 + 1 }}.
                                    </span>
                                    <span
                                    v-html="item.title"
                                    :id="item.title"
                                    ></span>
                            </div>
                            
                            <div class="biaoji-container">
                                <div class="biaoji">
                                    <el-tooltip class="item" effect="dark" content="取消标记" placement="top">
                                    <svg v-if="item.bjStatus == true" class="icon" @click="biaoji(item, index2)">
                                        <use xlink:href="#iconbiaoji" />
                                    </svg>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" content="标记" placement="top">
                                    <svg v-if="item.bjStatus == false" class="icon" @click="biaoji(item, index2)">
                                        <use xlink:href="#iconmark" />
                                    </svg>
                                    </el-tooltip>
                                </div>
                                <div class="icon-analysis" @click="btnAnalysis(item,index2)">
                                    <i class="el-icon-chat-line-round" style="color: orange; margin-right: 10px;"></i>
                                    <span class="icon-label">查看解析</span>
                                </div>
                            </div>
                        </div>
                        <div class="choose" style="padding-left: 35px; line-height: 50px">
                        
                            <label :for="item.Id" class="xz-label">
                                <input :id="item.Id" :name="item.id" type="radio" @change="dui(index2, item)"  style="margin-right: 10px" />
                                对
                            </label>
                            
                            <label class="xz-label" :for="item.Id">
                                <input
                                :id="item.Id"
                                :name="item.id"
                                type="radio"
                                @change="cuo(index2, item)"
                                style="margin-right: 10px"
                            />
                                错
                            </label>
                            <div class="answer" v-if="item.Status==true">
                                <div class="right-key" v-for="(items, indexs) in item.answer" :key="indexs" :id="items.Name">
                                    <span v-if="items.IsRight == true">正确答案：正确</span>
                                    <span v-if="items.IsRight == false">正确答案：错误</span>
                                    <!-- <span v-if="items.IsCheck">你选择的答案：正确</span>
                                    <span v-else>你选择的答案：错误</span> -->
                                    <span v-if="abc[index2].CheckAnswer && abc[index2].CheckAnswer.Value=='true'">你选择的答案：正确</span>
                                    <span v-if="abc[index2].CheckAnswer && abc[index2].CheckAnswer.Value=='false'">你选择的答案：错误</span> 
                                </div>
                                <div class="no-answer" >
                                    <span v-if="item.MyCate == ''">你选择的答案：未作答</span>
                                </div>
                                <div class="facility-value">
                                    <span v-if="item.level == 127">难易度：易</span>
                                    <span v-if="item.level == 128">难易度：较易</span>
                                    <span v-if="item.level == 129">难易度：一般</span>
                                    <span v-if="item.level == 130">难易度：较难</span>
                                    <span v-if="item.level == 131">难易度：难</span>
                                </div>
                            </div>
                            <div class="analysis" v-if="item.Status==true">
                                <span>解析：{{ item.explain }}</span>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <!-- 填空题 -->
            <div class="dxt-questions" v-show="tkt != 0  && abc[QuestionIndex].type==4">
                <div class="title" v-show="tkt != 0 && abc[QuestionIndex].type==4">
                    <span style="padding-left: 30px">填空题</span>
                    <span style="padding-left: 10px">(共{{ tkt }}题，合计{{ tktSum }}分)</span>
                </div>
                <div class="questions-answers-box" v-for="(item, index4) in abc" :key="index4" v-show="item.type == 4 && index4==QuestionIndex" @click="btnindex(item,index4)" v-clickDown>
                    <div class="questions-answers" v-show="index4==QuestionIndex">
                        <div class="questions">
                            <div class="subject">
                                    <span>
                                        {{ index4 + 1 }}.
                                    </span>
                                    <span
                                    v-html="item.title"
                                    :id="item.title"
                                    ></span>
                            </div>
                            <div class="biaoji-container">
                                <div class="biaoji">
                                    <el-tooltip class="item" effect="dark" content="取消标记" placement="top">
                                    <svg v-if="item.bjStatus == true" class="icon" @click="biaoji(item, index4)">
                                        <use xlink:href="#iconbiaoji" />
                                    </svg>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" content="标记" placement="top">
                                    <svg v-if="item.bjStatus == false" class="icon" @click="biaoji(item, index4)">
                                        <use xlink:href="#iconmark" />
                                    </svg>
                                    </el-tooltip>
                                </div>
                                <div class="icon-analysis" @click="btnAnalysis(item,index4)">
                                    <i class="el-icon-chat-line-round" style="color: orange; margin-right: 10px;"></i>
                                    <span class="icon-label">查看解析</span>
                                </div>
                            </div>
                        </div>
                        <div class="choose">
                            <el-input
                                v-for="(items, indexs2) in item.answer"
                                @paste.native.capture.prevent="handlePaste"
                                :key="indexs2"
                                v-model="items.letter"
                                v-on:input="inputChange(index4, indexs2, item)"
                                placeholder="请输入内容"
                                style="
                                width: 95%;
                                padding-bottom: 20px;
                                "
                            >
                                <template slot="prepend">{{ indexs2 + 1 }}</template>
                            </el-input>
                            <div class="answer" v-if="item.Status==true">
                              <div
                                  v-for="(items, indexs) in item.answer"
                                  :key="indexs"
                                  :id="items.Name"
                                  class="right-key"
                              >
                                  <span class="select-keys">正确答案：{{ items.Name }}</span>
                                  <span class="tx-keys">
                                  你填写的答案：{{
                                  items.letter == "" ? "无" : items.letter
                                  }}
                                  </span>
                              </div>
                              <div class="facility-value">
                                  <span v-if="item.level == 127">难易度：易</span>
                                  <span v-if="item.level == 128">难易度：较易</span>
                                  <span v-if="item.level == 129">难易度：一般</span>
                                  <span v-if="item.level == 130">难易度：较难</span>
                                  <span v-if="item.level == 131">难易度：难</span>
                              </div>
                          </div>
                          <div class="analysis" v-if="item.Status==true">
                              <span>解析：{{ item.explain }}</span>
                          </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <!-- 问答题 -->
            <div class="dxt-questions" v-show="wdt != 0  && abc[QuestionIndex].type==5">
                <div class="title" v-show="wdt != 0 && abc[QuestionIndex].type==5">
                    <span style="padding-left: 30px">问答题</span>
                    <span style="padding-left: 10px">(共{{ wdt }}题，合计{{ wdtSum }}分)</span>
                </div>
                <div class="questions-answers-box" v-for="(item, index3) in abc" :key="index3" v-show="item.type == 5 && index3==QuestionIndex" @click="btnindex(item,index3)" v-clickDown>
                    <div class="questions-answers" v-show="index3==QuestionIndex">
                        <div class="questions">
                            <div class="subject">
                                    <span>
                                        {{ index3 + 1 }}.
                                    </span>
                                    <span
                                    v-html="item.title"
                                    :id="item.title"
                                    ></span>
                            </div>
                            <div class="biaoji-container">
                                <div class="biaoji">
                                    <el-tooltip class="item" effect="dark" content="取消标记" placement="top">
                                    <svg v-if="item.bjStatus == true" class="icon" @click="biaoji(item, index3)">
                                        <use xlink:href="#iconbiaoji" />
                                    </svg>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" content="标记" placement="top">
                                    <svg v-if="item.bjStatus == false" class="icon" @click="biaoji(item, index3)">
                                        <use xlink:href="#iconmark" />
                                    </svg>
                                    </el-tooltip>
                                </div>
                                <div class="icon-analysis" @click="btnAnalysis(item,index3)">
                                    <i class="el-icon-chat-line-round" style="color: orange; margin-right: 10px;"></i>
                                    <span class="icon-label">查看解析</span>
                                </div>
                            </div>
                        </div>
                        <div class="choose">
                            <el-input
                                v-for="(items, indexs2) in item.answer"
                                @paste.native.capture.prevent="handlePaste"
                                :key="indexs2"
                                v-model="item.letter"
                                type="textarea"
                                :rows="4"
                                v-on:input="inputChange(index3, indexs2, item)"
                                placeholder="请输入内容"
                                style="
                                width: 95%;
                                padding-top: 10px;
                                padding-bottom: 20px;
                                "
                            ></el-input>
                            <div class="answer" v-if="item.Status==true">
                                <div
                                    v-for="(items2, indexs) in item.answer"
                                    :key="indexs"
                                    class="right-key">
                                    <span class="select-keys">正确答案：{{items2.Name}}</span>
                                    <span class="select-keys">
                                        你填写的答案：{{item.letter == "" ? "无" : item.letter}}
                                    </span>
                                </div>
                                <div class="facility-value">
                                    <span v-if="item.level == 127">难易度：易</span>
                                    <span v-if="item.level == 128">难易度：较易</span>
                                    <span v-if="item.level == 129">难易度：一般</span>
                                    <span v-if="item.level == 130">难易度：较难</span>
                                    <span v-if="item.level == 131">难易度：难</span>
                                </div>
                            </div>
                            <div class="analysis" v-if="item.Status==true">
                                <span>解析：{{ item.explain }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
      </div>
      <!-- 答题卡 -->
      <div>
        <left @btnLeft="btnLfet" :class="[fix == true ? 'fixed' : 'leftzj']" ref="left"></left>
      </div>
      <div class="tj">
            <div class="switch-topics">
                <el-button type="text" style="border-bottom: 1px solid #DEDEDE; width: 100px; " :disabled="QuestionIndex==0" @click="btnLastQuestion">上一题</el-button>
                <el-button type="text" @click="btnNextQuestion" :disabled="QuestionIndex==abc.length-1">下一题</el-button>
            </div>
            <el-button style="width: 120px;" type="primary" @click="btnSubmit">提交试卷</el-button>
      </div>
      <div class="ts" v-if="dialogVisible1 == true || dialogVisible2 == true">
        <span>任点一处关闭</span>
      </div>
      <el-dialog
        :visible.sync="dialogVisible"
        width="20%"
        :show-close="false"
        style="margin-top: 10%"
        :close-on-click-modal="false"
        center
      >
        <div style="text-align: center; font-size: 20px">
          <span>是否开始考试</span>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="close()">取 消</el-button>
          <el-button type="primary" @click="open()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        :visible.sync="dialogVisible1"
        width="20%"
        :show-close="false"
        style="margin-top: 10%"
        center
      >
        <div style="text-align: center; font-size: 20px; margin-bottom: 20px">
          <span>你已退出一次，退出三次将自动交卷</span>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="dialogVisible2"
        width="20%"
        :show-close="false"
        style="margin-top: 10%"
        center
        
      >
        <div style="text-align: center; font-size: 20px; margin-bottom: 20px">
          <span>你已退出两次，退出三次将自动交卷</span>
        </div>
      </el-dialog>
    </div>
    <transition name="fade">
      <div class="progress" v-if="show">
        <div style="margin-top: 40px">
          交卷中
          <span id="a" style="display: none">.</span>
          <span id="b" style="display: none">.</span>
          <span id="c" style="display: none">.</span>
        </div>
        <div style="margin-top: 20px">
          <el-progress type="circle" :color="customColors" :percentage="percentage"></el-progress>
        </div>
        <div>
          <span v-if="this.percentage <= 25" style="font-size: 10px; color: gray">正在提交答案...</span>
          <span v-if="percentage <= 25" style="font-size: 10px; color: gray">正在提交答案...</span>
          <span
            v-if="percentage < 50 && percentage > 25"
            style="font-size: 10px; color: gray"
          >正在判分中...</span>
          <span
            v-if="percentage > 50 && percentage < 75"
            style="font-size: 10px; color: gray"
          >正在出分中...</span>
          <span
            v-if="percentage > 75"
            style="padding-left: 10px; font-size: 10px; color: gray"
          >正在改卷，请稍等！</span>
        </div>
      </div>
    </transition>
    <el-dialog title="提示" :visible.sync="submitDialogVisible" width="30%">
      <span>{{inforText}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="submitDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="Submit">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
//屏蔽粘贴
document.onpaste = function (event) {
  if (window.event) {
    event = window.event;
  }
  try {
    var the = event.srcElement;
    if (
      !(
        (the.tagName == 'INPUT' && the.type.toLowerCase() == 'text') ||
        the.tagName == 'TEXTAREA'
      )
    ) {
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
};
//屏蔽复制
document.oncopy = function (event) {
  if (window.event) {
    event = window.event;
  }
  try {
    var the = event.srcElement;
    if (
      !(
        (the.tagName == 'INPUT' && the.type.toLowerCase() == 'text') ||
        the.tagName == 'TEXTAREA'
      )
    ) {
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
};
//屏蔽剪切
document.oncut = function (event) {
  if (window.event) {
    event = window.event;
  }
  try {
    var the = event.srcElement;
    if (
      !(
        (the.tagName == 'INPUT' && the.type.toLowerCase() == 'text') ||
        the.tagName == 'TEXTAREA'
      )
    ) {
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
};
//屏蔽选中
document.onselectstart = function (event) {
  if (window.event) {
    event = window.event;
  }
  try {
    var the = event.srcElement;
    if (
      !(
        (the.tagName == 'INPUT' && the.type.toLowerCase() == 'text') ||
        the.tagName == 'TEXTAREA'
      )
    ) {
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
};
import vHeader from '../../header/index';
import left from '../paper/left';
import {
  SelectPaperQuestion,
  SelectPaperDetail,
  SelectPointExam,
  EnterPaper,
  SelectQuestion,
} from '../../../api/exam/paper';
export default {
  components: {
    vHeader,
    left,
  },
  data() {
    return {
        //弹框提示信息
        inforText: '',
        //提交弹框的显示和隐藏
        submitDialogVisible: false,
        jindu: '',
        zongjindu: '',
        abc: [],
        dxt: 0,
        dxtSum: 0,
        dxt: 0,//单选题
        dxtSum: 0,
        tkt: 0,//填空题
        tktSum: 0,
        tktInput:null,
        pdt: 0,//判断题
        pdtSum: 0,
        wdt: 0,//问答题
        wdtSum: 0,
        wdtInput:null,
        ddxt: 0,//多选题
        ddxtSum: 0,
        Status: false,
        paperId: localStorage.getItem('paperId'),
        Ids: localStorage.getItem('Id'),
        fix: false,
        PaperDetail: [],
        ExamDetail: [],
        dialogVisible: false,
        dialogVisible1: false,
        dialogVisible2: false,
        dialogVisible3: true,
        date: null,
        ExamStatus: true,
        loading: false, //遮罩层
        percentage: 0, //进度条进度
        customColors: [
            //进度条颜色变化
            { color: '#f56c6c', percentage: 20 },
            { color: '#e6a23c', percentage: 40 },
            { color: '#6f7ad3', percentage: 60 },
            { color: '#1989fa', percentage: 80 },
            { color: '#5cb87a', percentage: 100 },
        ],
        show: false, //vue动画加载
        fullscreen: false, //默认全屏状态
        frequency: 0, //计算退出考试次数
        QuestionIndex:0,//题目序号
        showQuestion:[],//保存自执行点击事件获取的index
        itemList:[],
    };
  },
  methods: {
    //查看解析
    btnAnalysis(item,index){
        this.$nextTick(()=>{
           this.abc[index].Status=true
        })
        // 刷新data中的数据
        this.$forceUpdate() 
    },
    //接收子级传过来的index
    btnLfet(index){
        this.QuestionIndex=index
    },
    btnindex(item,index){
        this.showQuestion.push(index)
    },
    //点击上一题
    btnLastQuestion(){
        this.QuestionIndex-=1
    },
    //点击下一题
    btnNextQuestion(){
        this.QuestionIndex+=1
    },
    //点击提交按钮
    btnSubmit() {
      this.submitDialogVisible = true;
      for (let k = 0; k < this.abc.length; k++) {
        // debugger
        if (this.abc[k].MyCate==true) {
          this.inforText = '是否现在交卷？';
        } else if(this.abc[k].MyCate == false) {
          this.inforText = '有试题未完成，是否现在交卷？';
        }
      }
    },
    //进度条变化
    Progress() {
      let res = [];
      let res2 = [];
      res = res.concat(
        this.abc.map((c) => {
          if (c.MyCate == true) {
            res2.push(c.Status);
          }
          return c.Status;
        })
      );
      this.zongjindu = res.length;
      this.jindu = res2.length;
    },
    getList() {
        debugger
      let para = {
        pagerId: this.paperId,
        examId:this.Ids
      };
      SelectPaperQuestion(para).then((res) => {
          // debugger
        for (let i = 0; i < res.result.length; i++) {
          res.result[i].answer = JSON.parse(res.result[i].answer);
          // debugger
          res.result[i].bjStatus = false;
          res.result[i].MyCate = false;
          res.result[i].value = '';
          res.result[i].CheckAnswer = [];
          if (res.result[i].type == 1) {
            this.dxt += 1;
            this.dxtSum += res.result[i].score;
          } else if (res.result[i].type == 2) {
            this.ddxt += 1;
            this.ddxtSum += res.result[i].score;
          } else if (res.result[i].type == 3) {
            this.pdt += 1;
            this.pdtSum += res.result[i].score;
          } else if (res.result[i].type == 5) {
            this.wdt += 1;
            this.wdtSum += res.result[i].score;
             for (let index = 0; index < res.result[i].answer.length; index++) {
              res.result[i].answer[index].letter = '';
            }
          } else if (res.result[i].type == 4) {
            this.tkt += 1;
            this.tktSum += res.result[i].score;
            for (let index = 0; index < res.result[i].answer.length; index++) {
              res.result[i].answer[index].letter = '';
            }
          }
        }
        this.abc = res.result;
        // debugger
      });
    },
    radioChange(index, indexs, item) {
      this.abc[index].answer.map((v, i) => {
        if (i == indexs) {
          v.IsCheck = true;
          this.abc[index].MyCate = true;
          this.$refs.left.Selected(index, indexs, item);
          this.abc[index].CheckAnswer = {
            QuestionId: item.id,
            Value: indexs + 1,
          };
        } else {
          v.IsCheck = false;
          this.abc[index].MyCate = true;
          this.$refs.left.Selected(index, indexs, item);
          this.abc[index].CheckAnswer = {
            QuestionId: item.id,
            Value: indexs + 1,
          };
        }
      });
      this.Progress();
    },
    checkboxChange(index, indexs, item) {
      if (this.abc[index].answer[indexs].IsCheck == true) {
        this.abc[index].MyCate = true;
        this.$refs.left.Selected(index, indexs, item);
        this.abc[index].CheckAnswer.push({
          QuestionId: item.id,
          Value: indexs + 1,
        });
      } else if (this.abc[index].answer[indexs].IsCheck == false) {
        this.abc[index].CheckAnswer.splice(indexs, 1);
      }
      if (this.abc[index].CheckAnswer.length == 0) {
        this.abc[index].MyCate = false;
        this.$refs.left.Selected(index, indexs, item);
      }
      this.Progress();
    },
    dui(index, item) {
        debugger
      this.abc[index].answer[0].IsCheck = true;
      this.abc[index].CheckAnswer = { QuestionId: item.id, Value: 'true' };
      this.abc[index].MyCate = true;
      this.Progress();
      this.$refs.left.Selected(index, 0, item);
    },
    cuo(index, item) {
        debugger
      this.abc[index].answer[0].IsCheck = false;
      this.abc[index].CheckAnswer = { QuestionId: item.id, Value: 'false' };
      this.abc[index].MyCate = true;
      this.Progress();
      this.$refs.left.Selected(index, 0, item);
    },
    inputChange(index, indexs, item) {
      for (let i = 0; i < this.abc[index].answer.length; i++) {
        if (this.abc[index].answer[i].Name != '') {
          this.abc[index].MyCate = true;
          this.$refs.left.Selected(index, indexs, item);
        } else if (this.abc[index].answer[i].Name == '') {
          this.abc[index].MyCate = false;
          this.$refs.left.Selected(index, indexs, item);
        }
      }
      this.Progress();
    },
    biaoji(item, index) {
      if (item.bjStatus == 0) {
        item.bjStatus = true;
        this.$refs.left.bj(item, index);
        this.$message({
          type: 'success',
          message: '已标记!',
        });
      } else {
        item.bjStatus = false;
        this.$refs.left.bj(item, index);
        this.$message({
          type: 'success',
          message: '取消标记!',
        });
      }
    },
    //动画加载
    loadings() {
      let _this=this
      this.show = true;
      if (this.percentage != 100) {
        // this.loading = true;
        this.stop();
        let s = setInterval(() => {
          this.percentage += 1;
          if (this.percentage == 100) {
            clearInterval(s);
            setTimeout(() => {
              // this.loading = false;
            }, 1000);
            this.$message({
              type: 'success',
              message: '提交成功!',
            });
            this.move();
            this.show = false;
            this.percentage = 0;
            // this.screen();
            setTimeout(() => {
              let allscore = 0;
              let res = [];
              for (let i = 0; i < this.abc.length; i++) {
                if (this.abc[i].CheckAnswer.length == 0) {
                  this.abc[i].CheckAnswer = { QuestionId: 0, Value: 0 };
                }
                res.push(this.abc[i].CheckAnswer);
              }
              for (let k = 0; k < _this.abc.length; k++) {
                if (_this.abc[k].MyCate == true) {
                    if(_this.abc[k].type == 1){
                        for (let j = 0; j < _this.abc[k].answer.length; j++) {
                            if (_this.abc[k].answer[j].IsRight == true &&_this.abc[k].answer[j].IsCheck == true) {
                                _this.abc[k].IsRight=true
                                allscore += _this.abc[k].score;
                                }else{
                                _this.abc[k].IsRight=false
                            }
                        }
                    }else if (_this.abc[k].type == 2) {
                        // let count=0
                        let flag=0
                        for (let j = 0; j < _this.abc[k].answer.length; j++) {
                            if (!(_this.abc[k].answer[j].IsRight==_this.abc[k].answer[j].IsCheck)) {
                                flag++;//答错的选项个数 
                            }
                        }
                        if(flag>0){//如果错误答案数量》0,就不加分,否则加分
                            _this.abc[k].IsRight=false
                             allscore +=0
                        } else{
                            _this.abc[k].IsRight=true
                            allscore += _this.abc[k].score;
                        }
                    } 
                    else if (this.abc[k].type == 3) {
                        for (let j = 0; j < this.abc[k].answer.length; j++) {
                            if (this.abc[k].answer[j].IsRight == this.abc[k].answer[j].IsCheck) {
                                    this.abc[k].IsRight=true
                                    allscore += this.abc[k].score;
                            }else{
                                this.abc[k].IsRight=false
                            }
                        }
                    }else if (this.abc[k].type == 4) {
                        let answerLegth=this.abc[k].answer.length
                        let newAnswer
                        for (let j = 0; j < answerLegth; j++) {
                            let Ids = this.abc[k].answer.map(item => item.letter);
                            let arr = new Array();
                            this.abc[k].answer.forEach((item, index) => {
                                if (!Ids.includes(item.Name)) {
                                arr.push(item);
                                }
                            });//去掉填写正确的
                            newAnswer = arr.length;//剩下的都是填写错误的
                        }
                        if(newAnswer==answerLegth){
                                this.abc[k].IsRight=false
                                allscore +=0
                            }else if(newAnswer>0){
                                allscore += (this.abc[k].score*((answerLegth - newAnswer)/answerLegth));
                                this.abc[k].IsRight=false
                            }else if(newAnswer==0){
                                 allscore += this.abc[k].score;
                                 this.abc[k].IsRight=true
                            }
                        
                    }
                } else {
                    allscore += 0;
                }
              }
              this.submitDialogVisible = false;
              alert(allscore);
              this.$router.push({
                path:'/paperDetail',query:{score: allscore}
              })
            }, 1000);
          }
        }, 50);
      }
    },
    //主动提交
    Submit() {
      this.loadings();
      this.submitDialogVisible = false;
    },
    //禁止滚动
    stop() {
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = 'hidden';
      document.addEventListener('touchmove', mo, false); //禁止页面滑动
    },
    //取消滑动限制
    move() {
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ''; //出现滚动条
      document.removeEventListener('touchmove', mo, false);
    },
    //全屏
    screen() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
    //粘贴无操作
    handlePaste() {
      //粘贴会触发来到这里,无操作就行
    },
    //查询试卷信息
    getpaper() {
      let para = {
        id: this.paperId,
      };
      SelectPaperDetail(para).then((res) => {
        this.PaperDetail = res.result;
      });
    },
    //查询考试信息
    getexam() {
      let para = {
        id: this.Id,
      };
      SelectPointExam(para).then((res) => {
        this.ExamDetail = res.result;
      });
    },
    EnterPaper() {
      this.dialogVisible3 = false;
      //this.screen();
      let para = {
        examId: this.paperId,
        createUserId: this.user.id,
      };
      EnterPaper(para).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: '请开始作答',
            type: 'success',
          });
        } else {
          this.$message.error('服务器故障，请稍后重试');
        }
      });
    },
  },
  created() {
    //左悬浮div吸顶
    window.onscroll = () => {
      var scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      if (scrollTop >= 418) {
        this.fix = true;
      } else if (scrollTop < 418) {
        this.fix = false;
      }
    };
    this.getexam();
    //获取当前时间
    let _this = this;
    this.timer = setInterval(() => {
      var aaa = new Date();
      var year = aaa.getFullYear();
      var month = aaa.getMonth() + 1;
      var day = aaa.getDate();
      var hours = aaa.getHours();
      var minutes = aaa.getMinutes();
      var seconds = aaa.getSeconds();
      if (month <= 9) {
        month = '0' + month;
      }
      if (minutes <= 9) {
        minutes = '0' + minutes;
      }
      if (hours <= 9) {
        hours = '0' + hours;
      }
      if (seconds <= 9) {
        seconds = '0' + seconds;
      }
      _this.date =
        year +
        '-' +
        month +
        '-' +
        day +
        ' ' +
        hours +
        ':' +
        minutes +
        ':' +
        seconds;
      let a = new Date(
        year + '-' + month + '-' + day + ' ' + hours + ':' + minutes
      );
      let b = new Date(this.ExamDetail.endTime);
      if (a > b) {
        this.ExamStatus = false;
      }
    }, 1000);
    this.getList();
    this.getpaper();
    this.user = JSON.parse(this.$store.state.User.infos); //获取用户个人信息
    //监测是否失去焦点
    if (this.paperId != null) {
      window.onblur = this.aaa;
    }
  },
  //自执行点击事件
  directives:{
      clickDown:{
          inserted(el,binging){
              el.click()
          }
      }
  },
  mounted() {
    // if (this.Status == true) {
    //   for (let i = 0; i < this.abc.length; i++) {
    //     for (let j = 0; j < this.abc[i].answer.length; j++) {
    //       if (this.abc[i].answer[j].IsRight) {
    //         this.abc[i].value = this.abc[i].answer[j].Id;
    //       }
    //     }
    //   }
    // }
  },
  watch: {
    dialogVisible: {
      handler() {
        if (this.dialogVisible == false) {
          clearInterval(this.timer);
        }
      },
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
}
.zhuti {
  width: 50%;
  height: 800px;
  background-color: white;
  margin-top: 20px;
  margin-left: 30%;
}
.all-questions,.dxt-questions{
    height: 100%;
}
.title {
  width: 100%;
  height: 40px;
  padding-top: 15px;
  font-size: 18px;
  background-color: #fafafa;
  border-left: 1px dashed rgb(226, 223, 223);
  border-right: 1px dashed rgb(226, 223, 223);
  border-bottom: 1px dashed rgb(226, 223, 223);
  border-top: 1px dashed rgb(226, 223, 223);
}
li {
  list-style: none;
  font-size: 30px;
  padding-bottom: 15px;
}
.leftzj {
  position: absolute;
  left: 15%;
  top: 498px;
}
.tj {
  position: fixed;
  right: 100px;
  bottom: 80px;
}
.fixed {
  position: fixed;
  left: 15%;
  top: 10px;
}
.icon {
  width: 1em;
  height: 1em;
  font-size: 20px;
}
.icons {
  width: 1em;
  height: 1em;
  font-size: 15px;
}
.bj {
  background-color: #1a8cfe;
}
.questions {
  display: flex;
  flex-direction: column;
  width: 50%;
  height: 80%;
  justify-content: space-between;
  align-items: baseline;
  margin-right: 20px;
  border: 1px solid rgb(226, 223, 223);
  padding-top: 20px;
}
.choose{
    width: 50%;
    height: 80%;
    border: 1px solid rgb(226, 223, 223);
    padding-top: 20px;
    padding-left: 10px;
}
.questions-answers {
  /* border: 1px solid rgb(226, 223, 223); */
  margin-top: 20px;
  margin-bottom: 20px;
  /* padding-top: 20px; */
  display: flex;
  height: 100%;
}
.questions-answers-box{
    height: 100%;
    padding-bottom: 50px;
}
.answer {
  display: flex;
  flex-direction: column;
  width: 92%;
  border-top: 1px dashed rgb(226, 223, 223);
}
.analysis {
  width: 92%;
  border-top: 1px dashed rgb(226, 223, 223);
  line-height: 40px;
}
.mychange {
  display: flex;
  width: 150px;
  margin-top: 10px;
}
.rightanswer {
  display: flex;
  width: 150px;
  margin-top: 10px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.progress {
  z-index: 2000;
  text-align: center;
  position: fixed;
  left: 39.5%;
  top: 35%;
  height: 250px;
  width: 400px;
  border: 1px solid rgb(226, 223, 223);
  border-radius: 5px;
  background-color: #fafafa;
}
.subject{
    display: flex;
    align-items: baseline;
    margin-left: 10px;
}
.xz-label{
  font-size: 15px;
  display: flex;
  width: 100%;
  align-items: baseline;
}
.xz-label:hover{
  background-color: whitesmoke;
}
.switch-topics{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid gainsboro;
    font-size: 14px;
    height: 97px;
    width: 120px;
    margin-bottom: 10px;
}
/* .biaoji{
background-color: blue;
} */
.biaoji-container{
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;
}
.biaoji-container .icon-analysis{
    width: 82px;
}
.right-key{
    display: flex;
    flex-direction: column;
}
.no-answer{
    margin-top: 10px;
}
.facility-value{
    margin-top: 10px;
    color: blue;
}
.select-keys{
    margin-top: 10px;
}
.tx-keys{
   margin-top: 10px;
   padding-bottom: 10px;
   border-bottom: 1px solid gainsboro;
}
</style>